"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Building = void 0;
const core_1 = require("@openhps/core");
const SymbolicSpace_1 = require("./SymbolicSpace");
let Building = class Building extends SymbolicSpace_1.SymbolicSpace {
    getLocalBounds() {
        const bounds = this.getBounds();
        if (bounds.length === 0) {
            return [];
        }
        const hasElevation = bounds.reduce((a, b) => a + b.altitude, 0) / bounds.length !== bounds[0].altitude;
        const localBounds = [new core_1.Absolute2DPosition(0, 0)];
        for (let i = 1; i < bounds.length / (hasElevation ? 2 : 1); i++) {
            const b1 = bounds[i - 1];
            const b2 = bounds[i];
            const d = b1.distanceTo(b2);
            const a = b1.angleTo(b2) - this.rotationQuaternion.toEuler().z;
            const prev = localBounds[i - 1];
            const positionVector = new core_1.Vector2(prev.x, prev.y);
            localBounds.push(new core_1.Absolute2DPosition().fromVector(positionVector.add(new core_1.Vector2(d, 0).rotateAround(new core_1.Vector2(0, 0), -a))));
        }
        return localBounds;
    }
    transform(position, options) {
        const origin = this.origin;
        if (origin === undefined) {
            return position;
        }
        const angle = this.rotationQuaternion.toEuler().yaw;
        if (position instanceof core_1.GeographicalPosition && options && options.inverse) {
            const d = origin.distanceTo(position);
            const a = angle - origin.bearing(position);
            const localOrigin = this.getLocalBounds()[0].clone();
            const localOriginVector = new core_1.Vector2(localOrigin.x, localOrigin.y);
            localOriginVector.add(new core_1.Vector2(d).rotateAround(new core_1.Vector2(0, 0), core_1.AngleUnit.DEGREE.convert(a, core_1.AngleUnit.RADIAN)));
            localOrigin.fromVector(new core_1.Vector3(localOriginVector.x, localOriginVector.y, 0).applyMatrix4(this.translationMatrix));
            return localOrigin;
        }
        else if (position instanceof core_1.GeographicalPosition) {
            return position;
        }
        else if (position instanceof core_1.Absolute3DPosition) {
            const geoPos = origin
                .destination(angle, position.x, core_1.AngleUnit.DEGREE, core_1.LengthUnit.METER)
                .destination(angle - 90, position.y, core_1.AngleUnit.DEGREE, core_1.LengthUnit.METER);
            if (geoPos.altitude === undefined) {
                geoPos.altitude = 0;
            }
            geoPos.altitude += position.z;
            geoPos.fromVector(geoPos.toVector3().applyMatrix4(this.translationMatrix));
            return geoPos;
        }
        else if (position instanceof core_1.Absolute2DPosition) {
            const newPosition = origin
                .destination(angle, position.x, core_1.AngleUnit.DEGREE, core_1.LengthUnit.METER)
                .destination(angle - 90, position.y, core_1.AngleUnit.DEGREE, core_1.LengthUnit.METER);
            newPosition.fromVector(newPosition.toVector3().applyMatrix4(this.translationMatrix));
            return newPosition;
        }
        else {
            return position;
        }
    }
};
exports.Building = Building;
exports.Building = Building = __decorate([
    (0, core_1.SerializableObject)()
], Building);
//# sourceMappingURL=Building.js.map